import { render, staticRenderFns } from "./RoadmapSection.vue?vue&type=template&id=058eb5ec&"
import script from "./RoadmapSection.vue?vue&type=script&lang=js&"
export * from "./RoadmapSection.vue?vue&type=script&lang=js&"
import style0 from "./RoadmapSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports